import { useCallback } from 'react';

import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useToast,
  ModalHeader,
  ModalFooter,
  VStack,
  HStack,
} from '@chakra-ui/react';

import { SubmitHandler, useForm } from 'react-hook-form';

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { useColumnModal } from '../../hooks/columnModal';

import { Select } from '../shared/Select';
import { Input } from '../shared/Input';
import { Checkbox } from '../shared/Checkbox';

interface IColumn {
  columnId: string;
}

type ColumnFormData = {
  operator: string;
};

const columnFormSchema = yup.object().shape({
  operator: yup.string().required('Operador obrigatório'),
});

export function ColumnModal({ columnId }: IColumn) {
  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(columnFormSchema),
  });

  const { isSubmitting, errors } = formState;

  const toast = useToast();

  const { isOpen, onClose } = useColumnModal();

  const handleColumn: SubmitHandler<ColumnFormData> = useCallback(
    async ({ operator }) => {
      try {
        // TODO: Fazer a requisição para o backend buscando as configurações
      } catch (error) {
        toast({
          title: `Endereço de e-mail e/ou senha incorreta.`,
          status: 'error',
          isClosable: true,
          position: 'bottom-right',
        });
      }
    },
    [toast],
  );

  return (
    <Modal size="md" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent borderRadius="xl">
        <ModalHeader color="gray.900">Opções da Coluna</ModalHeader>
        <ModalBody>
          <VStack w="100%" as="form" onSubmit={handleSubmit(handleColumn)}>
            <Select label="Máscara" error={errors.mask} {...register('mask')}>
              <option value="date">dd/MM/yyyy</option>
            </Select>

            <HStack w="100%">
              <Select
                label="Alinhamento"
                error={errors.alignment}
                {...register('alignment')}
              >
                <option value="left">Esquerda</option>
                <option value="right">Direita</option>
                <option value="center">Centro</option>
                <option value="justify">Justificado</option>
              </Select>
              <Select
                label="Ordenação"
                error={errors.ordination}
                {...register('ordination')}
              >
                <option value="ascending">Ascedente</option>
                <option value="downward">Descendente</option>
              </Select>
            </HStack>

            <HStack w="100%" align="flex-end">
              <Input
                type="number"
                label="Largura (cm)"
                error={errors.width}
                {...register('width')}
              />

              <Checkbox
                label="Quebrar linha"
                error={errors.breakLine}
                {...register('breakLine')}
                mb={3}
              />
            </HStack>

            <Select
              label="Totalizar"
              error={errors.totalize}
              {...register('totalize')}
            >
              <option value="count">Contar</option>
              <option value="countDifferent">Contar Distintos</option>
            </Select>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Fechar
          </Button>
          <Button type="submit" isLoading={isSubmitting}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
